$(function()
{
	$(el('mainContainer')).on('click','#btnCurrentValue',function()
	{
		showCurrentSettingValue();
	});

	$(el('mainContainer')).on('click','#btnChangeTheme',function()
	{
		var sTheme = $(el('edtChangeTheme')).val();
		changeTheme(sTheme, "the theme has been changed to " + sTheme);
	});

	$(el('mainContainer')).on('click','#btnReloadTheme',function()
	{
		var sTheme = $(el('edtReloadTheme')).val();
		reloadTheme(sTheme, "the theme has been changed to " + sTheme);
	});

	$(el('mainContainer')).on('keyup','#edtPassword',function(e)
	{
		if(e.keyCode == 13)
		{
			var sLogin = $(el('edtUserName')).val();
			var sPassword = $(el('edtPassword')).val();
			loginUser(sLogin,sPassword);
		}
	});

	$(el('mainContainer')).on('click','#btnLoginUser',function()
	{
		var sLogin = $(el('edtUserName')).val();
		var sPassword = $(el('edtPassword')).val();
		loginUser(sLogin,sPassword);
	});
});

function changeTheme(sValue, sMessage)
{
	// clear current feedback
	clearErrors();

	var sParams = "&value=" + encodeURIComponent(sValue);
	var oCall   = callAjax('changeTheme', sParams, 'POST');
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			// successfully saved
			showAlert('info', sMessage, false, 3000);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function reloadTheme(sValue, sMessage)
{
	// clear current feedback
	clearErrors();

	var sParams = "&value=" + encodeURIComponent(sValue);
	var oCall   = callAjax('reloadTheme', sParams, 'POST');
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			// successfully saved
			showAlert('info', sMessage, false, 3000);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function loginUser(sLogin, sPassword)
{
	// clear current feedback
	clearErrors();

	var sParams = '&login=' + encodeURIComponent(sLogin) + "&password=" + encodeURIComponent(sPassword);
	var oCall   = callAjax('loginManagementUser', sParams, 'POST');
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			// successfully saved
			window.location = '/' + sCurrentLanguageCode;
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}


function showCurrentSettingValue()
{
	// hide value
	var oCurrentValue = $('#currentSettingValue');
	oCurrentValue.removeClass('visible');

	var sParams = '&code=' + encodeURIComponent($(el('edtSettingCode')).val());
	var oCall   = callAjax('getCurrentSettingValue', sParams, 'POST');
	oCall.success(function(oData)
	{
		// add value or error
		if(oData.errorType === "")
		{
			oCurrentValue.html(oData.html);
		}
		else
		{
			oCurrentValue.html(oData.errorMessage);
		}

		// show value
		oCurrentValue.addClass('visible');
	});
}
